var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500px", persistent: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function(ref) {
                  var on = ref.on
                  return [
                    _c(
                      "span",
                      _vm._g({}, on),
                      [
                        _vm._t("default", [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var tooltip = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            { attrs: { icon: "" } },
                                            tooltip
                                          ),
                                          [_c("v-icon", [_vm._v("edit")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("global.edit")) + " ")]
                          )
                        ])
                      ],
                      2
                    )
                  ]
                }
              }
            ],
            null,
            true
          ),
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v(_vm._s(_vm.$t("settings.userSubstitute.dialogTitle")))
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.formValid,
                        callback: function($$v) {
                          _vm.formValid = $$v
                        },
                        expression: "formValid"
                      }
                    },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.computedAvailableUsers,
                          label:
                            _vm.$t(
                              "settings.userSubstitute.fields.absentUser.name"
                            ) + "*",
                          rules: _vm.validators.absent_user_id
                        },
                        model: {
                          value: _vm.contextUserSubstitute.absent_user_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.contextUserSubstitute,
                              "absent_user_id",
                              $$v
                            )
                          },
                          expression: "contextUserSubstitute.absent_user_id"
                        }
                      }),
                      _c("v-autocomplete", {
                        attrs: {
                          items: _vm.computedAvailableUsers,
                          label:
                            _vm.$t(
                              "settings.userSubstitute.fields.substituteUser.name"
                            ) + "*",
                          rules: _vm.validators.substitute_user_id
                        },
                        model: {
                          value: _vm.contextUserSubstitute.substitute_user_id,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.contextUserSubstitute,
                              "substitute_user_id",
                              $$v
                            )
                          },
                          expression: "contextUserSubstitute.substitute_user_id"
                        }
                      }),
                      _c("date-time-picker-computed", {
                        attrs: {
                          "date-time-model":
                            _vm.contextUserSubstitute.from_date,
                          label: _vm.$t(
                            "settings.userSubstitute.fields.fromDate.name"
                          ),
                          placeholder: _vm.$t(
                            "settings.userSubstitute.fields.fromDate.placeholder"
                          )
                        },
                        on: {
                          "update:dateTimeModel": function($event) {
                            return _vm.$set(
                              _vm.contextUserSubstitute,
                              "from_date",
                              $event
                            )
                          },
                          "update:date-time-model": function($event) {
                            return _vm.$set(
                              _vm.contextUserSubstitute,
                              "from_date",
                              $event
                            )
                          }
                        }
                      }),
                      _c("date-time-picker-computed", {
                        attrs: {
                          "date-time-model": _vm.contextUserSubstitute.to_date,
                          label: _vm.$t(
                            "settings.userSubstitute.fields.toDate.name"
                          ),
                          placeholder: _vm.$t(
                            "settings.userSubstitute.fields.toDate.placeholder"
                          )
                        },
                        on: {
                          "update:dateTimeModel": function($event) {
                            return _vm.$set(
                              _vm.contextUserSubstitute,
                              "to_date",
                              $event
                            )
                          },
                          "update:date-time-model": function($event) {
                            return _vm.$set(
                              _vm.contextUserSubstitute,
                              "to_date",
                              $event
                            )
                          }
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: _vm.$t(
                            "settings.userSubstitute.fields.comment.name"
                          )
                        },
                        model: {
                          value: _vm.contextUserSubstitute.comment,
                          callback: function($$v) {
                            _vm.$set(_vm.contextUserSubstitute, "comment", $$v)
                          },
                          expression: "contextUserSubstitute.comment"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      nativeOn: {
                        click: function($event) {
                          _vm.dialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                        color: "blue darken-1",
                        text: ""
                      },
                      on: { click: _vm.save }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.save")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }